









import CheckboxMarked from '@icons/CheckboxMarked'
import CheckboxBlankOutline from '@icons/CheckboxBlankOutline'
import CheckboxIntermediate from '@icons/CheckboxIntermediate'
export default
  props: ['theme', 'border', 'selected', 'checked']
  computed:
    className: -> [
      @theme or 'dark'
      (@border ? true and not @checked? and @selected != false) and 'border'
      @checked? and 'left'
      @selected and 'selected'
    ]
  components: {
    CheckboxMarked
    CheckboxBlankOutline
    CheckboxIntermediate
  }
